import { render, staticRenderFns } from "./DashboardCustomers.vue?vue&type=template&id=face1eae"
import script from "./DashboardCustomers.vue?vue&type=script&lang=js"
export * from "./DashboardCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports